@if (config.options.length > 1) {
  <fieldset
    [ngClass]="'form-group--' + config.displayType"
    role="radiogroup"
    [attr.aria-required]="isRequired ? 'true' : 'false'"
    [attr.aria-invalid]="control.hasError ? 'true' : null"
  >
    @switch (config.displayType) {
      @case (radioDisplayType.list) {
        @for (opt of config.options; track opt) {
          <div class="option" [class.selected]="group.get(config.name)?.value === opt.value">
            <ng-container [ngTemplateOutlet]="radioButton" [ngTemplateOutletContext]="{ $implicit: opt }"></ng-container>
          </div>
        }
      }
      @default {
        @for (opt of config.options; track opt) {
          <ng-container [ngTemplateOutlet]="radioButton" [ngTemplateOutletContext]="{ $implicit: opt }"></ng-container>
        }
      }
    }
  </fieldset>
}
<ng-template #radioButton let-opt [formGroup]="group">
  <div class="radio-option">
    <input
      [id]="config.name + '_' + opt.value"
      type="radio"
      [value]="opt.value"
      [name]="config.name"
      [formControlName]="config.name"
      [checked]="opt.selected || config.value === opt.value"
      (change)="onChange()"
    />
    <label
      [for]="config.name + '_' + opt.value"
      [style.background-color]="config.color && (opt.selected || formControl?.value === opt.value) && '#' + config.color.color"
      [style.color]="config.color && !opt.selected && formControl?.value !== opt.value && '#' + config.color.color"
      [style.box-shadow]="config.color && 'inset 0px 0px 0px 2px #' + config.color.color"
    >
      {{ opt.text }}
    </label>
  </div>
</ng-template>
